<template>
  <div class="px-5 py-5">
    <slot name="acceptors"/>
    <KeyValue
      :caption="$t('Application.WhoCreated')"
      data-qa="who-created">
      <div class="flex gap-5">
        <UserIcon
          :name="application.creator ? application.creator.fullName : ''"
          size="28"
          :src="application.creator ? application.creator.avatar : ''"/>
        <div>
          <div>
            {{ (application.creator ? application.creator.fullName : '') || $t('Common.NoData') }}
          </div>
          <div class="px-0 subheader">
            {{ (application.creator && application.creator.department
              ? application.creator.department.name : '') || $t('Common.NoData') }}
          </div>
        </div>
      </div>
    </KeyValue>
    <KeyValue
      :caption="$t('Application.WhereToSend')"
      class="mt-5"
      data-qa="where-to-send">
      <div
        v-if="application.receiver">
        <div>{{ application.receiver.name }}</div>
        <div>{{ application.receiver.address }}</div>
      </div>
      <div
        v-else>
        {{ $t('Common.NoData') }}
      </div>
    </KeyValue>
  </div>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import KeyValue from 'components/common/KeyValue.vue'

export default {
  name: 'PurchaseInfo',
  components: {
    UserIcon,
    KeyValue
  },
  props: {
    application: {
      type: Object,
      required: true,
    },
  },
}
</script>
